const fields = [
  {
    dataIndex: 'index',
    key: 'index',
    title: '序号',
    width: 80,
    scopedSlots: {
      customRender: 'subscript'
    }
  },
  {
    dataIndex: 'title',
    key: 'title',
    title: '公告标题',
    width: 190,
    scopedSlots: {
      customRender: 'TextAction'
    }
  },
  {
    dataIndex: 'publishTime',
    key: 'publishTime',
    title: '发布日期',
    width: 120
  },
  {
    dataIndex: 'statusText',
    key: 'statusText',
    title: '状态',
    width: 100,
    scopedSlots: {
      customRender: 'color'
    }
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 130,
    scopedSlots: {
      customRender: 'action'
    }
  }
]

const formRow = [
  {
    span: 12,
    label: '公告标题',
    component: 'AInput',
    placeholder: '请输入公告标题',
    prop: 'title',
    allowClear: true
  }
  // {
  //   span: 7,
  //   label: '发布日期',
  //   component: 'ASelect',
  //   placeholder: '请选择发布日期',
  //   prop: 'searchValue',
  //   list: [
  //     { label: '全部', value: '0' },
  //     { label: '近一个月', value: '1' },
  //     { label: '近3个月', value: '2' },
  //     { label: '近半年', value: '3' },
  //     { label: '近一年', value: '4' },
  //   ],
  // },
]

const slotOpt = [
  {
    slot: 'TextAction',
    component: 'TextAction',
    cb: 'toDetail'
  },
  {
    slot: 'action',
    component: 'Action',
    list: [
      { name: '编辑', cb: 'edit' },
      // { name: '发布', cb: 'issue', divider: true },
      { name: '删除', cb: 'singleDelete', divider: true }
    ]
  }
]

module.exports = {
  fields,
  formRow,
  slotOpt
}
